export const util = {
    wordCase(value: string) {
        return value.trim().toLowerCase().replaceAll(/\s+/g," ").split(" ").map((word) => word.charAt(0).toUpperCase()+word.substring(1)).join(" ");
    }
};